<template>

    <div id='app_content'>
        
        <a class="site-logo" v-bind:href="front_api">
            <img src="/webroot/img/logos/IKEA_logo.svg" class="" alt="IKEA">
        </a>
        
        <div class="fixed-container">
            
            <div class="container text-center">
                <b-alert :show="alert.show_time"
                    dismissible
                    @dismissed="alert.show_time=0"
                    fade
                    :variant="alert.type"
                    v-html="alert.content">
                </b-alert>
            </div>
            
        </div>
        
        <div v-if="is_loading" class="preloadLoader">
            <div class="spinner-border" role="status">
              <span class="sr-only">{{this.$gettext("Cargando...")}}</span>
            </div>
        </div>
        
        <div class="catalog-wrapper" v-if="catalog != undefined" v-bind:class="{'active':sidenav.show, 'mobile': is_mobile}">
            <div class="catalog-pages" v-bind:class="{'mobile': pages_shown == 1}" v-bind:style="{width: catalog_size.width+'px', height: catalog_size.height+'px'}">
                <div v-for="(page, index) in current_pages" v-bind:key="page.number">
                    <CatalogPage 
                        @showtooltip="showTooltip"
                        @hidetooltip="hideTooltip"
                        @updatetooltipposition="updateTooltipPosition"
                        @openurl="openUrl"
                        @openitem="openItem"
                        @gotopage="goToPageNumber"
                        v-bind:is_last="(current_page >= catalog.page_ids.length)"
                        v-bind:show_zoom_icon="true"
                        v-bind:is_mobile="is_mobile"
                        v-bind:catalog_size="catalog_size"
                        v-bind:viewbox_size="viewbox_size"
                        v-bind:pages_shown="pages_shown"
                        v-bind:is_first="(current_page == 1)"
                        v-bind:position="index"
                        v-bind:page="page"
                        @zoom='zoomPage'/>
                </div>
            </div>

            <div class="catalog-navigation"  v-bind:class="{'active':sidenav.show}">
                <div class="prev-page button prev_button" v-if="current_page != 1" data-direction="prev" @click="prevPage" v-bind:style="{width: catalog_size.navWidth+'px'}"><div class="icon"><i class="display-1 fundament-icon-chevron-left-thin-24"></i></div></div>
                <div class="next-page button next_button" data-direction="next" @click="nextPage" v-bind:style="{width: catalog_size.navWidth+'px'}"><div class="icon"><i class="display-1 fundament-icon-chevron-right-thin-24"></i></div></div>
            </div>

            <div class="catalog-bottom-navigation" v-bind:class="{'navigation-opened': catalog_bottom_navigation.shown }">
                <div class='bottom-navigation-bar'>
                    <div class="nav-icons">
                        <div v-if="catalog_bottom_navigation.shown" class="nav-pages-catalogs">
                            <div class="nav-el mr-3" @click='changeBottomNavType("pages")' v-bind:class="{'active':catalog_bottom_navigation.type == 'pages'}">
                                {{this.$gettext("Páginas")}}
                            </div>
                            <div class="nav-el" @click='changeBottomNavType("catalogs")' v-bind:class="{'active':catalog_bottom_navigation.type == 'catalogs'}">
                                {{this.$gettext("Catálogos")}}
                            </div>
                        </div>


                        <div class="nav-actions ml-auto">
                            <div class="icon-wrapper">
                                <!--<i class="searchSize fundament-icon-search-thin-24 mr-3" alt="search"></i>-->
                            </div>
                            <div class="icon-wrapper bg mr-3" @click='toggleFullScreen()'>
                                <i class="" v-bind:class="{'fundament-icon-resize-expand-24':!fullscreen, 'fundament-icon-resize-contract-24':fullscreen}" alt="fullscreen"></i>
                            </div>
                            <!--                            <div v-else class="icon-wrapper bg" @click='toggleFullScreen()'>
                                                            <i class="fundament-icon-resize-contract-thin-24" alt="fullscreen"></i>
                                                        </div>-->
                            <div class="icon-wrapper menuClose align-center bg" @click='toggleBottomNav()'>
                                <span v-if='!catalog_bottom_navigation.shown'>{{ this.$gettext("Menú") }}</span>
                                <span v-else>{{ this.$gettext("Cerrar") }}</span>
                                <div v-if='catalog_bottom_navigation.shown' class="close-iconWrapper">
                                    <i class="closeSize fundament-icon-cross-thin-24" alt=""></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="menu-content" v-if='catalog_bottom_navigation.shown'>
                    <div v-if="catalog_bottom_navigation.type == 'pages'" class="d-flex catalog-images p-4">
                        <div v-for="(page, index) in catalog.pages" v-bind:key="page.number" class="thumbnail-wrapper" >
                            <div class="d-inline">
                                <div>
                                    <div class="page-thumbnail">
                                        <img @click="navigateToPage(index)" v-bind:src="page.image_small" class="img-fluid" />
                                    </div>
                                    <div class="thumbnail-text">{{page.name}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="catalog_bottom_navigation.type == 'catalogs'" class="d-flex catalog-images p-4">
                        <div v-for="catalog in catalogs" v-bind:key="catalog.id" class="thumbnail-wrapper" >
                            <div class="d-inline">
                                <div @click="openCatalog(catalog.id)">
                                    <div class="page-thumbnail">
                                        <img v-bind:src="catalog.image_small" class="img-fluid" />
                                    </div>
                                    <div class="thumbnail-text">{{catalog.name}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <b-modal 
                ref='zoom_modal'
                v-bind:hide-footer="true"
                size="lg"
                v-model="zoom.show">
                <div class="catalog-fullpage">
                    <div class="catalog-wrapper" v-if="catalog != undefined" v-bind:class="{'active':sidenav.show}">
                        <div class="catalog-pages" v-bind:style="{width: (catalog_size.width / pages_shown)*zoom.multiplier +'px', height: catalog_size.height*zoom.multiplier+'px'}">
                            <CatalogPage 
                                @showtooltip="showTooltip"
                                @hidetooltip="hideTooltip"
                                @openitem="openItemFromModal"
                                @openurl="openUrl"
                                @gotopage="goToPageNumber"
                                @updatetooltipposition="updateTooltipPosition"
                                v-bind:is_mobile="is_mobile"
                                v-bind:catalog_size="catalog_size"
                                v-bind:show_zoom_icon="false"
                                v-bind:pages_shown="pages_shown"
                                v-bind:viewbox_size="viewbox_size"
                                v-bind:is_last="false"
                                v-bind:is_first="false"
                                v-bind:page="zoom.page" />
                        </div>
                    </div>
                </div>
                
                <template v-slot:modal-title>
                    <!-- Emulate built in modal header close button action -->
                    <div class='zoom_inputs'>
                        <span class='zoom_span'>Zoom:</span>
                        <b-button variant="light" @click="decreaseZoom()"><i class=''>-</i></b-button>
                        <div class='zoom_percent'>
                            <span>{{zoom_percentage}}%</span>
                        </div>
                        <b-button variant="light" @click="increaseZoom()"><i class=''>+</i></b-button>
                    </div>
                </template>
                
            </b-modal>
        </div>
        <div v-else>
            <div class="catalogs-full-list container">
                <!-- All catalogs -->
                <div class='row text-white'>
                    <div class='col-12 text-center'>
                        <h5 class='display-6 p-5 title'>{{this.$gettext("Seleccione entre los catálogos que están actualmente disponibles")}}</h5>
                    </div>
                </div>
                <div class="row justify-content-center px-4 py-2">
                    <div v-for="catalog in catalogs" v-bind:key="'full_'+catalog.id" class="thumbnail-wrapper m-3" @click="openCatalog(catalog.id)">
                        <div class="page-thumbnail">
                            <img v-bind:src="catalog.image_small" class="img-fluid" />
                        </div>
                        <div class="thumbnail-text">{{catalog.name}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div id="sidenav" class="sidenav" v-bind:class="{'active':sidenav.show}">
            <div class="card">
                <div class="card-header close">
                    <button @click='closeSidenav()' type="button" class="close-legend">
                        <span aria-hidden="true"><span>Close</span></span>
                    </button>
                </div>
                <div class='card-body'>
                    <div class="sidenav-col" v-html='sidenav.content' ref="sidenavContent">

                    </div>
                </div>
            </div>
        </div>

        <div ref="tooltipElem" class='tooltip-element tooltip show' v-if="tooltip.show && !is_mobile && tooltip.content.length > 0" v-bind:style="{top:tooltip.position.y+'px', left: tooltip.position.x+'px'}">
            <div class='tooltip-inner' v-html="tooltip.content"></div>
        </div>
        <div id="polygonTooltipMobile" class="show" v-if="tooltip.show && is_mobile">
            <div class="polygonTooltipClose" @click.prevent="hideTooltip()">X</div>
            <div class="polygonTooltipContent">
                <div class="tooltip-content" v-html="tooltip.content" @click="tooltipClick()"></div>
            </div>
        </div>
</div>

</template>

<script>

    import VueGtm from '@gtm-support/vue2-gtm';

    import Vue from 'vue';
    import CatalogPage from './catalog/CatalogPage.vue'
    import slick from "slick-carousel";
    import JQuery from 'jquery'
    window.$ = JQuery;
    window.$.slick = slick;
    var $ = window.$;
    
    export default {
        name: 'Catalog',
        components: {
            CatalogPage
        },
        data: function () {
            
            var websiteUrl = "/";
            if(/^(localhost|192.168.33.11)/.test(window.location.host)){
                websiteUrl = "https://islas4dev-es.deswebislas.com/";
            }
            
            var catalog_id = this.$route.query.id;

            return {
                alert: {
                    show_time: 0,
                    type: "success",
                    content: ""
                },
                is_loading: true,
                api: websiteUrl+"catalogsapi/v1/",
                front_api: websiteUrl,
                catalog_id: catalog_id,
                cached_polygons: {},
                catalog_size: {width: 0, height: 0, navWidth: 0},
                viewbox_size: {width: 0, height: 0},
                catalog: null,
                pages_shown: 2, // mostrar una sola página(v. mobile) = 1 
                temp_content: null,
                current_pages: null,
                cached_pages: {},
                tooltipClick: function(){},
                current_page: 0,
                from_page: 0,
                max_page: 0,
                is_mobile: false,
                page_transition: null,
                catalogs: [],
                tooltips_content: {},
                sidenav: {
                    show: false,
                    content: ""
                },
                tooltip: {
                    show: false,
                    content: "",
                    position: {x: 0, y: 0},
                    polygon_path: null,
                },
                catalog_bottom_navigation: {
                    shown: false,
                    type: "pages"
                },
                zoom: {
                    show: false,
                    page: null,
                    multiplier: 2,
                    xpos: 0,
                    ypos: 0
                },
                fullscreen: false
            };
        },
        mounted: function () {
            
            this.$router.beforeEach((to, from, next) => {
                
                if(to.query.id != undefined && to.query.id != "" && (this.catalog == undefined || to.query.id != this.catalog.id)){
                    this.getCatalogContent(to.query.id);
                }
                let page = to.query.page != undefined ? Number.parseInt(to.query.page) : null;
                if(page != undefined && Number.isInteger(page) && this.catalog != undefined && this.from_page != (page -1) ){
                    this.showPagesFromIndex(page - 1, false);
                }
                next();
            })
            this.getFrontUrl();
            this.catalogResize();
            if(this.catalog_id != undefined && this.catalog_id.length > 0){
                this.getCatalogContent(this.catalog_id);
            }else{
                this.getAllCatalogs();
            }
            window.addEventListener("resize", this.catalogResize);
        },
        destroyed() {
            window.removeEventListener("resize", this.catalogResize);
        },
        methods: {
            toggleLoading: function(loading){
                this.is_loading = loading;
                this.tooltip.show = false;
            },
            setViewboxSize: function () {
                this.viewbox_size.width = this.catalog_size.width / this.pages_shown;
                this.viewbox_size.height = this.catalog_size.height;
            },
            goToPageNumber: function(page_number){
                this.zoom.show = false;
                var index = (parseInt(page_number) - 1);
                if (this.pages_shown > 1){
                    index = index - (page_number%2);
                }
                this.navigateToPage(index);
            },
            navigateToPage: function (page_index) {
                this.showPagesFromIndex(parseInt(page_index));
            },
            showFirstPage: function () {
                this.showPagesFromIndex(0);
            },
            showAlert: function(message, type) {
                var time = 5;
                switch(type){
                    case "success":
                        time = 3;
                        break;
                }
                this.alert.show_time = time;
                this.alert.type = type;
                this.alert.content = message;
            },
            showPagesFromIndex(from_idx, register_history) {
                register_history = register_history == undefined ? true : register_history;
                var to_idx = from_idx + this.pages_shown;
                if (from_idx <= 0) {
                    from_idx = 0;
                    to_idx = 1;
                }
                this.showPages(from_idx, to_idx);
                
                if(register_history){
                    let currentQuery = this.$route.query;
                    let query = {id:currentQuery.id, page:from_idx + 1};
                    this.$router.push({query: query }).catch(()=>{});  
                }
            },
            showPages: function (from, to) {
                this.hideTooltip();
                this.from_page = from;
                this.current_page = to;
                this.current_pages = this.getPages(this.catalog.page_ids.slice(from, to));
            },
            getPages: function (page_numbers) {
                /**
                 * @todo: call api. and cache result.
                 */
                var pages = [];
                for (var i = 0; i < page_numbers.length; i++) {
                    var page_number = page_numbers[i];
                    for (var j = 0; j < this.temp_content.length; j++) {
                        var page = this.temp_content[j];
                        if (page.number == page_number) {
                            pages.push(page);
                            j = this.temp_content.length;
                        }
                    }
                }
                return pages;

            },
            increaseZoom: function(){
                this.zoom.multiplier = this.zoom.multiplier + 0.1;
            },
            decreaseZoom: function(){
                this.zoom.multiplier = this.zoom.multiplier - 0.1;
                if(this.zoom.multiplier < 1){
                    this.zoom.multiplier = 1;
                }
            },
            zoomPage: function (page, xpospercent, ypospercent) {
                this.zoom.xpos = xpospercent * (this.catalog_size.width / this.pages_shown)*this.zoom.multiplier / 100;
                this.zoom.ypos = ypospercent * this.catalog_size.height*this.zoom.multiplier  / 100;
                this.zoom.page = page;
                this.zoom.show = true;
                this.zoom.multiplier = 2;
                this.hideTooltip();
                this.$nextTick(() => {  
                    setTimeout(() => {
                        $.zoom = this.$refs["zoom_modal"];
                        var y = this.zoom.ypos - ($.zoom.$refs["body"].clientHeight / 2);
                        var x = this.zoom.xpos - ($.zoom.$refs["body"].clientWidth / 2);
                        this.$refs["zoom_modal"].$refs["body"].scrollTo(x, y);                
                    }, 50);
                });
            },
            prevPage: function () {
                var from_idx = this.current_page - (this.pages_shown * 2);
                this.showPagesFromIndex(from_idx);
            },
            nextPage: function () {
                var from_idx = this.current_page;
                if (from_idx >= this.catalog.page_ids.length) {
                    return;
                }
                this.showPagesFromIndex(from_idx);
            },
            catalogResize: function () {

                var maxWidth = window.innerWidth;
                var maxHeight = window.innerHeight;

                var height = maxHeight;
                var width = maxWidth;

                var aspectRatio = 1.5;
                this.pages_shown = 2;
                if(this.isMobile()){
                    this.pages_shown = 1;
                    aspectRatio = 0.75;
                }

                if (maxWidth > maxHeight * aspectRatio) {
                    width = maxHeight * aspectRatio;
                } else {
                    width = maxWidth;
                    height = width / aspectRatio;
                }

                var navWidth = 50;
                if (width + (navWidth * 2) < maxWidth) {
                    navWidth = (maxWidth - width) / 2
                }

                this.catalog_size = {width: width, height: height, navWidth: navWidth};
                this.setViewboxSize();
            },
            updateTooltipPosition: function (event) {
                var tooltipHeight = $(this.$refs["tooltipElem"]).height();
                tooltipHeight = tooltipHeight == undefined || tooltipHeight <= 0 ? 150 : tooltipHeight;
                var max_x = window.innerWidth - 310;
                var max_y = window.innerHeight - tooltipHeight;
                var ypos = (event != undefined ? event.pageY : 0) + 10;
                var xpos = (event != undefined ? event.pageX : 0) + 10;

                xpos = xpos > max_x ? max_x : xpos;
                ypos = ypos > max_y ? max_y : ypos;

                this.tooltip.position = {
                    x: xpos,
                    y: ypos
                };
            },
            showTooltip: function (event, polygon_path, tooltip_click_callback) {
                this.getTooltipContent(polygon_path, (content) => {
                    this.tooltip.content = content;
                    this.tooltip.show = true;
                    this.tooltip.polygon_path = polygon_path;
                    this.tooltipClick = tooltip_click_callback;
                    this.updateTooltipPosition(event);
                });
            },
            hideTooltip: function () {
                this.tooltip.content = "";
                this.tooltip.show = false;
                this.tooltip.polygon_path = null;
            },
            toggleBottomNav: function () {
                this.catalog_bottom_navigation.shown = !this.catalog_bottom_navigation.shown;
            },
            openUrl: function (url) {
                window.open(url);
            },
            openItemFromModal: function (item_id){
                this.zoom.show = false;
                this.openItem(item_id);
            },
            openItem: function (item_id) {
                if(item_id == undefined || item_id.length == 0){
                    return;
                }
                this.closeSidenav();
                this.toggleLoading(true);
                var api = this.api + "products/item_slidenav";
                api+="?hide[favourites]=false&hide[btnItem]=false";
                var data = {id: item_id};
                this.$http.get(api, {params: data}).then((result) => {
                    
                    if(result.data.length == 0){
                        this.showAlert(this.$gettext("Artículo no encontrado"), "warning");
                        return;
                    }

                    if(this.getCookie('client') === 'app'){
                        // if is inspire
                        let url = result.data.replace("?inspireapp", "");
                        window.location.href = url;
                    }else{
                        this.sidenav.content = result.data;
                        this.$nextTick(() => {
                            this.$nextTick( ()=> {
                                this.sidenavListeners();
                            })
                        });
                        this.openSidenav();
                    }

                }).finally(()=>{
                    // if is inspire
                    if(this.getCookie('client') === 'app'){
                        setTimeout(()=>{
                            this.toggleLoading(false);
                        }, 500);
                    }else{
                        this.toggleLoading(false);
                    }
                });
            },
            setupGtm(gtmId, analyticsId){
              if (!gtmId){
                return;
              }
              Vue.use(VueGtm, {
                id: gtmId, // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryPararms: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}]
                enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
                debug: true, // Whether or not display console logs debugs (optional)
                vueRouter: this.$router, // Pass the router instance to automatically sync with router (optional)
              });
              if (this.$gtm.enabled() && analyticsId) {
                window.dataLayer=window.dataLayer||[];
                this.gtag('js',new Date());this.gtag('config',analyticsId);
              }
            },
            gtag: function(){
              window.dataLayer.push(arguments);
            },
            addToCart: function(id_item){
                this.makeApiPost("addToCart",{items:[{"id_item":id_item}]},
                    (result) => {
                        if(result.data.success){
                            this.showAlert(this.$gettext("Artículo añadido correctamente!"),"success");
                        }else{
                            this.showAlert(this.$gettext("Ha ocurrido un error al intentar añadir el artículo."), "warning");
                        }
                    },
                    () => {
                        this.showAlert(this.$gettext("Ha ocurrido un error al intentar añadir el artículo."),"warning");
                    },
                );
            },
            closeSidenav: function () {
                this.sidenav.show = false;
                this.sidenav.content = "";
            },
            openSidenav: function () {
                if(this.sidenav.content.length > 0){
                    this.sidenav.show = true;
                }
            },
            getCookie: function(name){
                const value = `; ${document.cookie}`;
                const parts = value.split(`; ${name}=`);
                if (parts.length === 2) return parts.pop().split(';').shift();
            },
            toggleFullScreen: function () {
                var elem = document.getElementById("app_content");
                if(this.fullscreen){
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.mozCancelFullScreen) { /* Firefox */
                        document.mozCancelFullScreen();
                    } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
                        document.webkitExitFullscreen();
                    } else if (document.msExitFullscreen) { /* IE/Edge */
                        document.msExitFullscreen();
                    }
                    this.fullscreen = false;
                }else{
                    if (elem.requestFullscreen) {
                        elem.requestFullscreen();
                    } else if (elem.msRequestFullscreen) {
                        elem.msRequestFullscreen();
                    } else if (elem.mozRequestFullScreen) {
                        elem.mozRequestFullScreen();
                    } else if (elem.webkitRequestFullscreen) {
                        elem.webkitRequestFullscreen();
                    }
                    this.fullscreen = true;
                }
            },
            changeBottomNavType(type) {
                this.catalog_bottom_navigation.type = type;
                if (type == "catalogs") {
                    this.getAllCatalogs();
                }
            },
            getAllCatalogs: function (page) {
                if (page == undefined || page < 1) {
                    page = 1;
                }
                this.toggleLoading(true);
                this.makeApiRequest(
                    "catalogs?page=" + page,
                    (res) => {
                        this.toggleLoading(false);
                        this.catalogs = res.data;
                    },
                    (error) => {
                        this.toggleLoading(false);
                        console.log(error);
                    }
                );

            },
            openCatalog: function (id) {
                if(this.$route.query.id != id){
                    this.$router.push({query: { id: id, page: 1} }).catch(()=>{});
                }
            },
            getCatalogContent: function (id) {
                this.toggleLoading(true);
                this.makeApiRequest(
                        "catalogs/" + id,
                        (res) => {

                            if(res.data != undefined && res.data.id != undefined){

                                this.catalog = res.data;

                                this.catalog_id = this.catalog.id;

                                var pages = res.data.pages;

                                // get from catalog object.
                                this.max_page = pages.length;

                                // will be removed after having the page api
                                this.temp_content = pages;

                                this.catalog.page_ids = [];
                                for (var i = 0; i < this.temp_content.length; i++) {
                                    var page = this.temp_content[i];
                                    this.catalog.page_ids.push(page.number);
                                }

                                var nav_page = parseInt(this.$route.query.page);
                                if(nav_page != undefined && Number.isInteger(nav_page)){
                                    this.showPagesFromIndex(nav_page - 1);
                                }else{
                                    this.showFirstPage();
                                }
                                this.toggleLoading(false);

                            }else{
                                // catalog not found
                                this.getAllCatalogs();

                            }
                        },
                        (error) => {
                            /**
                             * @TODO:
                             */
                            console.log(error);
                            this.getAllCatalogs();
                        }
                );
            },
            getTooltipContent: function (path, callback) {

                if (this.tooltips_content[path.function_type] == undefined) {
                    this.tooltips_content[path.function_type] = {};
                }
                var content = this.tooltips_content;

                if (content[path.function_type][path.function_value] !== undefined &&
                    content[path.function_type][path.function_value] !== ""
                    ) {
                    callback(content[path.function_type][path.function_value]);
                    return;
                } else if (path.function_type == undefined || path.function_value == undefined) {
                    return;
                }

                if (this.tooltips_content[path.function_type][path.function_value] === ""){
                    // prevent multiple requests.
                    return;
                }
                this.tooltips_content[path.function_type][path.function_value] = "";

                var api = this.front_api + "api/polygon";
                var post_data = JSON.stringify({action: 'tooltip_content', path: path});
                this.tooltips_content[path.function_type][path.function_value] = "";
                this.$http.post(api, post_data).then((result) => {

                    if(result.data.tooltip != undefined){
                        this.tooltips_content[path.function_type][path.function_value] = result.data.tooltip;
                        callback(result.data.tooltip);
                    }
                });
            },
            getFrontUrl: function(){
                var api = this.api + "getFrontUrl";
                this.$http.get(api).then((result) => {
                    if(result.data.url != undefined && result.data.url.length > 0){
                        this.front_api = result.data.url.replace("http://islas4dev-es.deswebislas.com/", "http://islas4dev-es.deswebislas.com/");
                    }
                    if(result.data.locale != undefined && result.data.locale.length > 0){
                        Vue.config.language = result.data.locale;
                    }

                    if(result.data.gtm_id != undefined && result.data.gtm_id.length > 0){
                      this.setupGtm(result.data.gtm_id, result.data.ga_id);
                    }
                    if (result.data.is_app == true || this.getCookie('client') === 'app') {
                        // If is inspire, hide cookiebot
                        const style = document.createElement('style');
                        style.innerHTML = `
                            #CybotCookiebotDialog,
                            #CybotCookiebotDialogBodyUnderlay {
                                display: none !important;
                            }
                        `;
                        document.head.appendChild(style);
                    }
                }).finally(()=>{
                });
            },
            makeApiRequest: function (url, callbackOk, callbackError) {
                this.$http.get(this.api + url, {
                    headers: {
                        "Content-Type": 'application/json'
                    }
                }).then((result) => {
                    callbackOk(result);
                }).catch(error => {
                    callbackError(error);
                });
            },
            makeApiPost: function (url, data, callbackOk, callbackError) {
                var postData = {
                    headers: {
                        "Content-Type": 'application/json'
                    }
                };
                postData = $.extend(postData, data);
                
                this.$http.post(this.api + url, postData).then((result) => {
                    callbackOk(result);
                }).catch(error => {
                    console.log(error);
                    callbackError(error);
                });
            },
            isMobile: function(){
                if(window.innerWidth <= 992){
                    this.is_mobile = true;
                    return true;
                }else{
                    this.is_mobile = false;
                    return false;
                }
            },
            getUrlParam: function(paramName){
                var sPageURL = window.location.search.substring(1),
                    sURLVariables = sPageURL.split('&'),
                    sParameterName,
                    i;

                for (i = 0; i < sURLVariables.length; i++) {
                    sParameterName = sURLVariables[i].split('=');
                    if (sParameterName[0] === paramName) {
                        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
                    }
                }
                return "";
            },
            sidenavListeners: function(){
                $(this.$refs["sidenavContent"]).find('img:first').on('load', function(){
                    $('.productInfo-header[data-slider="sidenav"]:not(.slick-initialized)').slick({
                        autoplay: false,
                        autoplaySpeed: 8000,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        adaptiveHeight: false,
                        fade: false,
                        speed: 500,
                        dots: false,
                        infinite: true,
                        responsive: [
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 1
                                }
                            }
                        ]
                    });
                });

                $(this.$refs["sidenavContent"]).find('[data-slider="versions"]:not(.slick-initialized)').slick({
                    autoplay: false,
                    autoplaySpeed: 8000,
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    adaptiveHeight: false,
                    fade: false,
                    speed: 500,
                    dots: false,
                    infinite: true,
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 5
                            }
                        }
                    ]
                });


                $(this.$refs["sidenavContent"]).find('[data-selected]').unbind('click').click( function(event){
                    event.preventDefault(event);
                    var elem = $(event.currentTarget),
                        parent = elem.parent('[data-select-content]'),
                        siblings = elem.siblings('[data-select]');

                    if (parent.hasClass('active')) {
                        parent.removeClass('active');
                        elem.find('> .icon').css({'transform' : 'rotate(0deg)'});
                        siblings.removeClass('active').slideToggle(200);
                    } else {
                        parent.addClass('active');
                        elem.find('> .icon').css({'transform' : 'rotate(180deg)'});
                        siblings.addClass('active').slideToggle(200);
                    }
                });

                $(this.$refs["sidenavContent"]).find('[data-select-content]').find('[data-item]').unbind('click').click((event) => {
                    event.preventDefault();
                    this.openItem($(event.currentTarget).data("item"));
                })

                $(this.$refs["sidenavContent"]).find("[data-action='showsidenav']").unbind('click').click( ( event ) => {
                    event.preventDefault();
                    this.openItem($(event.currentTarget).data("item"));
                });

                $(this.$refs["sidenavContent"]).find("[data-action='buy']").click( ( event ) => {
                    event.preventDefault();
                    this.addToCart($(event.currentTarget).data("item"));
                });

                $(this.$refs["sidenavContent"]).find("[data-action='favorites']").remove();
                $(this.$refs["sidenavContent"]).find(".outOfStock").remove();
            }
        },
        computed: {
            zoom_percentage: function(){
                return Math.round(this.zoom.multiplier * 100);
            }
        }
    }
</script>
